import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../interceptors/request';
import reviewApprovalValues from '../variables/reviewApprovalValues';

const conduit = new Conduit(
  process.env.TWENTY_API_URL,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {

  /**
   * Retreives a user's session.
   *
   * @returns {AxiosPromise}
   */
  getSession() {
    return conduit.get('/session', [], []);
  },

  /**
   * Retrieves a list of filters.
   *
   * @returns {AxiosPromise}
   */
  getFilters() {
    return conduit.get('/filters', [], []);
  },

  /**
   * Retrieves a filter.
   */
  getFilter(id) {
    return conduit.get(`/filters/${id}`, [], []);
  },


  /**
   * Creates a new filter.
   *
   * @returns {AxiosPromise}
   */
  createFilter(name, product, brands) {
    return conduit.post('/filters', {
      name,
      product,
      brands,
    }, [], []);
  },

  /**
   * Updates a filter
   *
   * @param id
   * @param data
   * @returns {AxiosPromise}
   */
  updateFilter(id, data) {
    return conduit.put(`/filters/${id}`, data, []);
  },

  /**
   * Deletes a filter
   *
   * @param id
   */
  deleteFilter(id) {
    return conduit.delete(`/filters/${id}`, [], []);
  },

  /**
   * Retrieves available facilities options for a filter
   *
   * @param id
   * @returns {AxiosPromise}
   */
  getFilterFacilities(id) {
    return conduit.get(`/filters/facilities/${id}`, [], []);
  },

  /**
   * Updates filter facilities
   *
   * @param id
   * @param data
   * @returns {AxiosPromise}
   */
  updateFilterFacilities(id, data) {
    return conduit.put(`/filters/facilities/${id}`, data, []);
  },

  /**
   * @param offset
   * @param brandIds
   * @param domainIds
   * @param siteIds
   * @param approvalStatus
   * @returns {AxiosPromise}
   */
  getReviews(
    offset = 0,
    brandIds = [],
    domainIds = [],
    siteIds = [],
    approvalStatus = reviewApprovalValues.UNRESOLVED,
  ) {
    return conduit.post(`/review/reviews/paginated/${approvalStatus}`, {
      offset,
      brandIds,
      domainIds,
      siteIds,
    }, [], []);
  },

  /**
   * @param reviewIds
   * @returns {AxiosPromise}
   */
  approveReviews(reviewIds) {
    return conduit.post('/review/reviews/approval-status/approve', {
      reviewIds,
    }, [], []);
  },

  /**
   * @param reviewIds
   * @returns {AxiosPromise}
   */
  disapproveReviews(reviewIds) {
    return conduit.post('/review/reviews/approval-status/disapprove', {
      reviewIds,
    }, [], []);
  },

  /**
   * @returns {AxiosPromise}
   */
  getBrandsAndDomains() {
    return conduit.get('cms/get-brands-with-domains', [], []);
  },

  /**
   * @param brandIds
   * @param domainIds
   * @returns {AxiosPromise}
   */
  getApprovalStatusOverview(brandIds = [], domainIds = [], siteIds = []) {
    return conduit.post('/review/reviews/approval-values', {
      brandIds,
      domainIds,
      siteIds,
    }, [], []);
  },

  /**
   * @returns {AxiosPromise}
   */
  getBrandsAndAvailableDomains() {
    return conduit.get('review/available-domains', [], []);
  },

  /**
   * @param domainId
   * @param availableDomainId
   * @returns {AxiosPromise}
   */
  deleteAvailableDomain(domainId, availableDomainId) {
    return conduit.post('/review/available-domains/delete', {
      domainId,
      availableDomainId,
    }, [], []);
  },

  /**
   * @param domainId
   * @param availableDomainId
   * @returns {AxiosPromise}
   */
  addAvailableDomain({ domainId, availableDomainId }) {
    return conduit.post('/review/available-domains/add', {
      domainId,
      availableDomainId,
    }, [], []);
  },

  /**
   * @param reviewInformation
   * @returns {AxiosPromise}
   */
  updateReviewInformationText(reviewInformation) {
    return conduit.post('/review/review-information/update-review-information-text',
      reviewInformation,
      [], [],
    );
  },

  /**
   * Retrieves a list of sites in Twenty.
   * @returns {AxiosPromise}
   */
  getSites() {
    return conduit.get('/products/products/sites/with-area-country-product-type', [], []);
  },
};



// WEBPACK FOOTER //
// ./src/services/twenty-service.js